import React, { createContext, useState, useContext, useEffect } from "react";
import { getToken } from "./Api";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(false);
  const [username, setUsername] = useState("");
  const [familyID, setFamilyID] = useState("");
  const [guardianID, setGuardianID] = useState("");
  const [familyName, setFamilyName] = useState("");
  const [childID, setChildIDState] = useState(localStorage.getItem("childID") || null);

  const [loading, setLoading] = useState(true);

  const updateChildID = (id) => {
    setChildIDState(id);
    if (id) {
      localStorage.setItem("childID", id);
    } else {
      localStorage.removeItem("childID");
    }
  }

  useEffect(() => {
    checkAuth();
  });

  const checkAuth = async () => {
    try {
      const token = await getToken();
      if (token) {
        const decodedToken = decodeToken(token);
        // console.log("decoded token:", decodedToken);
        setAuth(true);
        setUsername(decodedToken.Email || "User");
        setFamilyID(decodedToken.FamilyID);
        setGuardianID(decodedToken.GuardianID);
        setFamilyName(decodedToken.FamilyName);
      } else {
        setAuth(false);
        setUsername("");
        setFamilyID("");
        setGuardianID("");
        setFamilyName("")
        setChildIDState(null);
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      setAuth(false);
    } finally {
      setLoading(false);
    }
  };

  function decodeToken(token) {
    try {
      const decoded = jwtDecode(token);
      return decoded;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  }

  if (loading) {
    return null;
  }

  return (
    <AuthContext.Provider value={{ auth, username, checkAuth, guardianID, familyID, familyName, childID, updateChildID }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
